// Test IDs for the scheduling flow (AI qualification + booking) on the contact section.
// See ./index.js for the recipe to add a new feature file. Keys camelCase, values kebab-case.

export const SCHEDULING = {
	slots: 'scheduling-slots',
	slotOption: 'scheduling-slot-option',
	confirmButton: 'scheduling-confirm-button',
	success: 'scheduling-success',
	unqualified: 'scheduling-unqualified',
};
